import { v4 as uuidv4 } from 'uuid';
import axios from './_axios';
import { beginApiCall, apiCallError } from './apiStatusActions';
import {
    LOGIN_SUCCESS,
    LOGIN_CLEAN,
    LOGIN_EXPIRADO,
    LOGIN_NOVA_PERMISSOES
} from './actionTypes';

export function carregadoFonteTabelaSucesso(login) {
    return { type: LOGIN_SUCCESS, login };
}

export function cleanLoginError() {
    return { type: LOGIN_CLEAN };
}

export function cleanLoginExpirado() {
    return { type: LOGIN_EXPIRADO };
}

export function novaPermissoes(paramPermissoes) {
    return { type: LOGIN_NOVA_PERMISSOES, permissoes: paramPermissoes };
}

/**
 * Actions
 * */
export const loginDev = body => async dispatch => {
    try {
        dispatch(beginApiCall());
        const req = await axios.post('auth/dev?versao=dev', body);
        if (req.status !== 200) {
            throw req;
        }

        axios.defaults.headers.common.Authorization = `Bearer ${req.data.token}`;
        return dispatch(carregadoFonteTabelaSucesso(req.data));
    } catch (error) {
        dispatch(apiCallError(error));
        throw error;
    }
};

/**
 * Actions
 * */
export const loginAuth = () => async dispatch => {
    try {
        dispatch(beginApiCall());
        const body = {
            token: uuidv4()
        };
        const req = await axios.post('auth', body);
        if (req.status !== 200) {
            throw req;
        }
        // return [body.token, req.data];
        return req.data;
    } catch (error) {
        dispatch(apiCallError(error));
        throw error;
    }
};

/**
 * Actions
 * */
export const getLoginDadosExtras = localToken => async dispatch => {
    try {
        dispatch(beginApiCall());
        const req = await axios.post('login', {
            token: localToken
        });

        if (req.status !== 200) {
            throw req;
        }

        axios.defaults.headers.common.Authorization = `Bearer ${req.data.token}`;
        return dispatch(carregadoFonteTabelaSucesso(req.data));
    } catch (error) {
        dispatch(apiCallError(error));
        throw error;
    }
};

/**
 * Actions
 * */
export const logout = () => async dispatch => {
    try {
        dispatch(beginApiCall());
        const body = {
            token: uuidv4()
        };
        const req = await axios.post('auth/logout', body);
        if (req.status !== 200) {
            throw req;
        }
        window.location.href = req.data;
    } catch (error) {
        dispatch(apiCallError(error));
        throw error;
    }
};
